import React from "react";
import { Link } from "react-router-dom";
import { FaToggleOff } from "react-icons/fa";
import PublicHeader from "./PublicHeader";
import AppHeader from "./AppHeader";

export default function FeatureUnavailable({ session, profile, intranet = false, management = false }) {
  return (
    <>
      {intranet ? <AppHeader variant={management ? "management" : "staff"} session={session} profile={profile} /> : <PublicHeader session={session} profile={profile} />}
      <main className="nhsuk-main-wrapper" role="main">
        <div className="nhsuk-width-container">
          <div className="pguh-feature-unavailable">
            <FaToggleOff aria-hidden="true" />
            <div>
              <span className="pguh-eyebrow">Temporarily unavailable</span>
              <h1>This page is currently disabled</h1>
              <p>A developer has temporarily disabled this page or service. No data has been deleted.</p>
              <Link className="nhsuk-button" to={intranet ? "/intranet/portal" : "/"}>Return to {intranet ? "the intranet" : "home"}</Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
